/**
 * Created by mykurisu on 2017/10/30.
 */
import React from 'react'
import { Dialog, Toast } from 'react-weui'
import axios from 'axios'
import { WKInfiniteScroll, WKSkeletonScreen, WKBottomBtn } from '../components/wk'
import { renderCouponMoney, isLZWKAPP, judgeAPPVersion, renderMoney, isLZWKAPPIpad } from '../utils'
import { NoneItem } from '../components/details'
import { toLiveroom } from '../utils/connectApp'
// eslint-disable-next-line no-redeclare
import { Dialog as NewDialog } from '../components/dialog'
import { CouponListSpecial } from './CouponListSpecial'
import '../css/page/MyCouponListPage.css'

const Wrapper = ({ children }) => children;

class CouponItem extends React.Component {

    handleHowToUse() {
        const { content } = this.props;
        switch (content.coupon.scope) {
            case 'weike':
                CouponListSpecial(content) // 处理一堆特例 券包，app之类的逻辑
                break;
            case 'liveroom':
                if (isLZWKAPP() || isLZWKAPPIpad()) return toLiveroom(content.coupon.liveroom_id)
                location.assign(`/liveroom/${content.coupon.liveroom_id}`);
                break;
            case 'lecture':
                if (isLZWKAPP() || isLZWKAPPIpad()) return this.toAppType('lecture', content.coupon.lecture_id)
                location.assign(`/lecture/${content.coupon.lecture_id}`);
                break;
            case 'channel':
                if (isLZWKAPP() || isLZWKAPPIpad()) return this.toAppType('channel', content.coupon.channel_id)
                location.assign(`/channel/${content.coupon.channel_id}`);
                break;
            case 'weike_app':
                if ((isLZWKAPP() || isLZWKAPPIpad()) && +content.coupon.bag_id === 40) return location.assign(`/coupons-bag/app/app-counpon?couponid=${content.coupon.bag_id}&inviter_id=${content.inviter_id}`)
                location.assign('lizhiweike://quality')
                break;
            case 'luck_coupon':
                if (isLZWKAPP() || isLZWKAPPIpad()) {
                    location.assign('lizhiweike://home')
                    return
                }
                location.assign('https://gio.ren/KOMa5asdJv7')
                break;
        }
    }

    toAppType(type, id) {
        if (isLZWKAPPIpad()) {
            return location.assign(`lizhiweike://${type}?${type}_id=${id}&is_has_coupon=true`)
        }
        if (window.systemType === 'ios') {
            if (judgeAPPVersion(410)) {
                return location.assign(`lizhiweike://${type}?${type}_id=${id}&is_has_coupon=true`)
            }
        }
        if (window.systemType === 'android') {
            if (judgeAPPVersion(310)) {
                return location.assign(`lizhiweike://${type}?${type}_id=${id}`)
            }
        }
        location.assign(`/${type}/${id}`);
    }

    renderScope() {
        const { content } = this.props;
        const { coupon } = content;
        switch (content.coupon.scope) {
            case 'weike':
                return '点击券面查看';
            case 'liveroom':
                if (coupon.threshold_enabled) {
                    return `直播间内满￥${renderMoney(coupon.threshold_price)}可用`
                }
                return '直播间通用';
            case 'lecture':
                return `课程【${coupon.object_name}】`;
            case 'channel':
                return `专栏【${coupon.object_name}】`;
            case 'weike_app':
                return `精选栏目的所有专栏`;
        }
    }

    renderTitle(coupon) { // tmd 后端返回字段格式不统一 坑死人
        if (coupon.title && coupon.title !== '') {
            return coupon.title
        } else if (coupon.coupon_name && coupon.coupon_name !== '') {
            return coupon.coupon_name
        } else if (coupon.name && coupon.name !== '') {
            return coupon.name
        }
    }

    render() {
        const { content } = this.props;
        const { coupon } = content;
        //=== 26、28的优惠券只显示在APP h5不显示 @姚丹
        if (!(isLZWKAPP() || isLZWKAPPIpad()) && (content.coupon.bag_id === 26 || content.coupon.bag_id === 28)) return null;
        return (
            <div className="list__item" onClick={() => this.handleHowToUse()}>
                <div className="item__right">
                    <div className="right__title">
                        {this.renderTitle(content.coupon)}
                    </div>
                    {content.coupon.scope === 'luck_coupon' ?
                        <div className="right__message">
                            <p>
                                <span>全场通用</span>
                                <span></span>
                            </p>
                            <p>
                                <span>适用范围：</span>
                                <span>仅限APP</span>
                            </p>
                            {coupon.deadline &&
                                <p>
                                    <span>有效期至：</span>
                                    <span>{coupon.deadline}</span>
                                </p>
                            }
                        </div>
                        :
                        <div className="right__message">
                            {content.coupon.scope === 'weike' ?
                                <p>
                                    <span>平台优惠券</span>
                                    <span></span>
                                </p>
                                :
                                <p>
                                    <span>直播间：</span>
                                    <span>{content.coupon.scope === 'weike_app' ? 'APP优惠券' : this.props.liveroomName}</span>
                                </p>
                            }
                            <p>
                                <span>适用范围：</span>
                                <span>{this.renderScope()}</span>
                            </p>
                            {content.coupon.deadline &&
                                <p>
                                    <span>有效期至：</span>
                                    <span>{content.coupon.deadline}</span>
                                </p>
                            }
                        </div>
                    }
                </div>
                <div className="item__left">
                    {/* <div className="left__side">
                        <img src={side} alt=""/>
                    </div> */}
                    <div className="left__content">
                        <div className="content__price">
                            {
                                coupon.price === 0 ?
                                    <span className="content__price__discount">
                                        <span>{coupon.discount}</span>
                                        <span style={{ marginLeft: '1px' }}>折</span>
                                    </span> :
                                    [
                                       <span>￥</span>,
                                       <span>{renderCouponMoney(coupon.price)}</span>
                                    ]
                            }
                        </div>
                        <div className="content__btn__background">
                            <div className="content__btn">
                                立即使用
                          </div>
                        </div>
                    </div>
                </div>
                <div className="item__bar__top"></div>
                <div className="item__bar__bottom"></div>
            </div >
        )
    }
}


class MyCouponListPage extends React.Component {

    constructor() {
        super();
        this.state = {
            addCouponDialogShow: false,
            addCouponDialogBtn: [
                {
                    type: 'default',
                    label: '取消',
                    onClick: () => {
                        this.setState({
                            addCouponDialogShow: false,
                            errormsg: null
                        })
                    }
                },
                {
                    type: 'primary',
                    label: '添加',
                    onClick: () => {
                        this.handleSubmit()
                    }
                }
            ],
            inputValue: '',
            list: null,
            has_more: null,
            next_offset: null,
            loading: false,
            errormsg: null,
            addLoading: false,
            dialogConfig: {},
            isDialogShow: false,
            isShowSuccess: false
        }
    }

    componentDidMount() {
        // ios审核屏蔽
        // if (isLZWKAPP() && isIos() && judgeAPPVersion(420)) {
        //     return alert('APP的优惠券功能已临时整改，如需查看，请前往“荔枝微课”公众号')
        // }
        this.handleGetCoupon();

        document.title = '我的优惠券';

        if (this.props.location.query.auto_focus === '1') {
            this.handleAddCoupon()
        }
    }

    handleGetCoupon() {

        axios.get(`/api/coupon/my_v2`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        list: res.data.data.coupons,
                        has_more: res.data.data.has_more,
                        next_offset: res.data.data.next_offset
                    })
                }
            })
    }

    handleAddCoupon() {
        // this.setState({
        //     addCouponDialogShow: true
        // })
        this.setState({
            isDialogShow: true,
            dialogConfig: {
                title: '添加优惠券',
                text: ['取消', '添加'],
                onCancel: () => {
                    this.setState({
                        isDialogShow: false,
                        errormsg: null
                    })
                },
                onSubmit: () => {
                    this.handleSubmit()
                }
            }
        })
    }

    handleInputValue(e) {
        this.setState({
            inputValue: e.target.value
        })
    }

    handleSubmit() {
        const { inputValue } = this.state;

        if (inputValue === '') {
            this.setState({
                errormsg: '优惠码不可为空'
            });
            return;
        }

        let data = new FormData();
        data.append('code', inputValue + '');
        data.append('scope', 'account');

        this.setState({
            addLoading: true
        }, () => {
            axios.post(`/api/coupon/accept`, data)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({
                            inputValue: '',
                            addCouponDialogShow: false,
                            addLoading: false,
                            isDialogShow: false,
                        }, () => {
                            /*let newcoupon = {
                             coupon: res.data.data.coupon,
                             liveroom_name: ''
                             }
                             let newlist = [].concat(newcoupon).concat(this.state.list);
                             this.setState({
                             list: newlist
                             })*/
                            this.showSuccessToast();
                            this.handleGetCoupon();
                        })
                    } else {
                        this.setState({
                            inputValue: '',
                            errormsg: res.data.msg,
                            addLoading: false,
                        })
                    }
                })
        });
    }

    showSuccessToast() {
        this.setState({ isShowSuccess: true })
        const timer = setTimeout(
          () => this.setState({ isShowSuccess: false }),
          3000
        )
      }
    
    handleLoadMore() {
        this.setState({
            loading: true
        }, () => {
            axios.get('/api/coupon/my_v2', {
                params: {
                    offset: this.state.next_offset
                }
            })
                .then((res) => {
                    if (res.data.code === 0) {
                        let newlist = this.state.list.concat(res.data.data.coupons);
                        this.setState({
                            list: newlist,
                            has_more: res.data.data.has_more,
                            next_offset: res.data.data.next_offset,
                            loading: false
                        })
                    }
                })
        });
    }

    renderList() {
        if (this.state.list.length === 0) {
            return (
                <div className="mycouponpage__list-noitem">
                    <NoneItem
                        img="https://static-1253442168.image.myqcloud.com/picture/5915685_56abb3878106a0d1d4d6b18128d2c7f2.jpg"
                        text="暂无可使用的优惠券"
                    />
                </div>
            )
        } else {
            return (
                <div className="mycouponpage__list">

                    {this.state.list.map((item) => (
                        item.coupon.bag_id ?
                            <CouponItem
                                content={item}
                                key={item.coupon.bag_id}
                                handleUseCoupon={(id) => this.handleUseCoupon(id)} />
                            : (
                                <CouponItem
                                    content={item}
                                    liveroomName={item.liveroom_name}
                                    key={item.coupon.id}
                                    handleUseCoupon={(id) => this.handleUseCoupon(id)} />
                            )
                    ))}

                    <WKInfiniteScroll
                        onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
                        isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                        distance={300} // 距离底部多少px触发
                        isKill={!this.state.has_more} // 不再监听滚动，一般是传has_more
                    />
                </div>
            )
        }
    }

    renderButton() {
        return (
            <div className="add__coupons">
                <div
                    className="add__coupons__buttons"
                    onClick={() => this.handleAddCoupon()}
                >
                    添加优惠券
          </div>
            </div>
        )
    }

    render() {
        // ios审核屏蔽
        // if (isLZWKAPP() && isIos() && judgeAPPVersion(420)) {
        //     return null
        // }
        // const btnContent = {
        //     text: '添加优惠券',
        //     bcolor: '#fff',
        //     border: '1px solid #F55C59',
        //     color: '#F55C59',
        //     method: () => {
        //         this.handleAddCoupon()
        //     }
        // };
        return (
            <div className="mycouponpage">
                {/* <Dialog type="ios" title={'添加优惠券'} buttons={this.state.addCouponDialogBtn}
                        show={this.state.addCouponDialogShow}>
                    <input placeholder="请输入优惠码" type="number" onChange={e => this.handleInputValue(e)} value={this.state.inputValue}/>
                    {this.state.errormsg &&
                    <p style={{fontSize: '10px', color: '#f76260', marginTop: '10px', textAlign: 'left'}}>{this.state.errormsg}</p>
                    }
                </Dialog> */}
                <NewDialog
                    show={this.state.isDialogShow}
                    dialogConfig={this.state.dialogConfig}
                >
                    <div>
                        <input
                            className="coupon__input"
                            placeholder="请输入优惠码"
                            type="number"
                            value={this.state.inputValue}
                            onChange={e => { this.handleInputValue(e) }}
                        />
                        {
                            <p
                                style={{
                                    fontSize: '12px',
                                    color: '#f76260',
                                    marginTop: '12px',
                                    textAlign: 'center'
                                }}
                            >
                                {this.state.errormsg}
                            </p>
                        }
                    </div>
                </NewDialog>
                <Toast icon="loading" show={this.state.addLoading}>
                    请稍等..
                </Toast>

                {this.state.list ?
                    this.renderList()
                    :
                    <WKSkeletonScreen num={3} />
                }
                {this.renderButton()}
                {/* <WKBottomBtn btnContent={btnContent}/> */}
                <Toast icon="success-no-circle" show={this.state.isShowSuccess}>
                    领取成功
                </Toast>
            </div>
        )
    }
}

export default MyCouponListPage


// WEBPACK FOOTER //
// ./src/pages/MyCouponListPage.js